const state = () => ({
  menuopen:false,
  apploaded:false,
  usermenuopen:false,
  mainframeloading:true,
  contentframeloading:false,
  tinyframeloading:false,
  successnotif:false,
  errornotif:false,
  successmessage:"",
  errormessage:"",
  submitting:false,
  deletedialog:false,
  deletedialogcontent:false,
  deletedstate:true,
  activemenuitem:null,
  viewdevice:"mobile",
  activetab:1,
  offcanvasmenu:false,
  notifications:false,  
  upload_progress:0,
  upload_progress_element:null,
  show_search_area:false,
  show_ticket_modal:false,
  show_notifications_modal:false,
  show_search_modal:false,
  usermenu:null,
  verificationdatatransfermodal:false,
  verificationdatatransferdata:null,
  filtertemplatessidebar:null,
  selectedfiltertemplate:null,
});
const getters = {
  menuopen(state){
    return state.menuopen
  },
  apploaded(state){
    return state.apploaded
  },
  usermenuopen(state){
    return state.usermenuopen
  },
  mainframeloading(state){
    return state.mainframeloading
  },
  contentframeloading(state){
    return state.contentframeloading
  },
  tinyframeloading(state){
    return state.tinyframeloading
  },
  successnotif(state){
    return state.successnotif
  },
  errornotif(state){
    return state.errornotif
  },
  successmessage(state){
    return state.successmessage
  },
  errormessage(state){
    return state.errormessage
  },
  submitting(state){
    return state.submitting
  },
  deletedialog(state){
    return state.deletedialog
  },
  deletedialogcontent(state){
    return state.deletedialogcontent
  },
  deletedstate(state){
    return state.deletedstate
  },
  activemenuitem(state){
    return state.activemenuitem
  },
  viewdevice(state){
    return state.viewdevice
  },
  activetab(state){
    return state.activetab
  },
  offcanvasmenu(state){
    return state.offcanvasmenu
  },
  notifications(state){
    return state.notifications
  },  
  upload_progress(state){
    return state.upload_progress
  },  
  upload_progress_element(state){
    return state.upload_progress_element
  },   
  show_search_area(state){
    return state.show_search_area
  }, 
  show_ticket_modal(state){
    return state.show_ticket_modal
  },
  show_notifications_modal(state){
    return state.show_notifications_modal
  }, 
  show_search_modal(state){
    return state.show_search_modal
  }, 
  usermenu(state){
    return state.usermenu
  },
  verificationdatatransfermodal(state){
    return state.verificationdatatransfermodal
  },
  verificationdatatransferdata(state){
    return state.verificationdatatransferdata
  },
  filtertemplatessidebar(state){
    return state.filtertemplatessidebar
  },
  selectedfiltertemplate(state){
    return state.selectedfiltertemplate
  },
};
const  mutations =  {
  SET_MENUOPEN(state,data){
    state.menuopen = data
  },
  SET_APP_LOADED(state,data){
    state.apploaded = data
  },  
  SET_USER_MENU_OPEN(state,data){
    state.usermenuopen = data
  },
  SET_MAINFRAME_LOADING(state,data){
    state.mainframeloading = data
  },
  SET_CONTENTFRAME_LOADING(state,data){
    state.contentframeloading = data
  },
  SET_TINYFRAME_LOADING(state,data){
    state.tinyframeloading = data
  },
  SET_SUCCESS_NOTIF(state,data){
    state.successnotif = data
  },
  SET_ERROR_NOTIF(state,data){
    state.errornotif = data
  },
  SET_SUCCESSMESSAGE(state,data){
    state.successmessage = data
  },
  SET_ERROMESSAGE(state,data){
    state.errormessage = data
  },
  SET_SUBMITTING(state,data){
    state.submitting = data
  },
  SET_DELETE_DIALOG(state,data){
    state.deletedialog = data
  },
  SET_DELETE_DIALOG_CONTENT(state,data){
    state.deletedialogcontent = data
  },
  SET_DELETED_STATE(state,data){
    state.deletedstate = data
  },
  SET_ACTIVE_MENU_ITEM(state,data){
    state.activemenuitem = data
  },
  SET_VIEW_DEVICE(state,data){
    state.viewdevice = data
  },
  SET_ACTIVE_TAB(state,data){
    state.activetab = data
  },
  SET_OFFCANVAS_MENU(state,data){
    state.offcanvasmenu = data
  },
  SET_NOTIFICATIONS(state,data){
    state.notifications = data
  },
  SET_UPLOAD_PROGRESS(state,data){
    state.upload_progress = data
  },
  SET_UPLOAD_PROGRESS_ELEMENT(state,data){
    state.upload_progress_element = data
  },
  SET_SHOW_SEARCH_AREA(state,data){
    state.show_search_area = data
  },
  SET_SHOW_TICKET_MODAL(state,data){
    state.show_ticket_modal = data
  },
  SET_SHOW_NOTIFICATIONS_MODAL(state,data){
    state.show_notifications_modal = data
  },
  SET_SHOW_SEARCH_MODAL(state,data){
    state.show_search_modal = data
  },
  SET_USERMENU(state,data){
    state.usermenu = data
  },
  SET_VERIFICATION_DATA_TRANSFER_MODAL(state,data){
    state.verificationdatatransfermodal = data
  },
  SET_VERIFICATION_DATA_TRANSFER_DATA(state,data){
    state.verificationdatatransferdata = data
  },
  SET_FILTRE_TEMPLATES_SIDEBAR(state,data){
    state.filtertemplatessidebar = data
  },
  SET_SELECTED_FILTER_TEMPLATE(state,data){
    state.selectedfiltertemplate = data
  },
};
const actions =  {
  setMenuOpen({commit},data)  {
    commit("SET_MENUOPEN",data)
  },
  setAppLoaded({commit},data)  {
    commit("SET_APP_LOADED",data)
  },
  setUserMenuOpen({commit},data)  {
    commit("SET_USER_MENU_OPEN",data)
  },
  setMainFrameLoading({commit},data)  {
    commit("SET_MAINFRAME_LOADING",data)
  },
  setContentFrameLoading({commit},data)  {
    commit("SET_CONTENTFRAME_LOADING",data)
  },
  setTinyFrameLoading({commit},data)  {
    commit("SET_TINYFRAME_LOADING",data)
  },
  setSuccessNotif({commit},data)  {
    commit("SET_SUCCESS_NOTIF",data)
  },
  setErrorNotif({commit},data)  {
    commit("SET_ERROR_NOTIF",data)
  },
  setSuccessMessage({commit},data)  {
    commit("SET_SUCCESSMESSAGE",data)
  },
  setErroMessage({commit},data)  {  
    commit("SET_ERROMESSAGE",data)
  },
  setSubmitting({commit},data)  {
    commit("SET_SUBMITTING",data)
  },
  setDeleteDialog({commit},data)  {
    commit("SET_DELETE_DIALOG",data)
  },
  setDeleteDialogContent({commit},data)  {
    commit("SET_DELETE_DIALOG_CONTENT",data)
  },
  setDeletedState({commit},data)  {
    commit("SET_DELETED_STATE",data)
  },
  setActiveMenuItem({commit},data)  {
    commit("SET_ACTIVE_MENU_ITEM",data)
  },
  setViewDevice({commit},data)  {
    commit("SET_VIEW_DEVICE",data)
  },
  setActiveTab({commit},data)  {
    commit("SET_ACTIVE_TAB",data)
  },
  setOffcanvasMenu({commit},data)  {
    commit("SET_OFFCANVAS_MENU",data)
  },
  setNotifications({commit},data)  {
    commit("SET_NOTIFICATIONS",data)
  },
  setUploadProgress({commit},data)  {
    commit("SET_UPLOAD_PROGRESS",data)
  },
  setUploadProgressElement({commit},data)  {
    commit("SET_UPLOAD_PROGRESS_ELEMENT",data)
  },
  setShowSearchArea({commit},data)  {
    commit("SET_SHOW_SEARCH_AREA",data)
  },
  setShowTicketModal({commit},data)  {
    commit("SET_SHOW_TICKET_MODAL",data)
  },
  setShowNotificationsModal({commit},data)  {
    commit("SET_SHOW_NOTIFICATIONS_MODAL",data)
  },
  setShowSearchModal({commit},data)  {
    commit("SET_SHOW_SEARCH_MODAL",data)
  },
  setUserMenu({commit},data)  {
    commit("SET_USERMENU",data)
  },
  setVerificationDataTransferModal({commit},data)  {
    commit("SET_VERIFICATION_DATA_TRANSFER_MODAL",data)
  },
  setVerificationDataTransferData({commit},data)  {
    commit("SET_VERIFICATION_DATA_TRANSFER_DATA",data)
  },
  setFilterTemplatesSidebar({commit},data)  {
    commit("SET_FILTRE_TEMPLATES_SIDEBAR",data)
  },
  setSelectedFilterTemplate({commit},data)  {
    commit("SET_SELECTED_FILTER_TEMPLATE",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

